@if (isAuthRoute) {
  <router-outlet></router-outlet>
} @else {
  <div class="app-shell">
    <app-sidebar
      [collapsed]="sidebarCollapsed"
      [roles]="roles"
      [isDarkTheme]="isDarkTheme"
      (toggleCollapse)="toggleSidebar()"
      (themeToggle)="toggleTheme()"
    ></app-sidebar>
    <div class="app-body" [class.sidebar-collapsed]="sidebarCollapsed">
      <!-- Topbar -->
      <header class="app-topbar">
        @if (pageTitle) {
          <div class="topbar-title">
            <mat-icon class="topbar-title-icon" fontSet="material-icons-outlined">{{ pageIcon }}</mat-icon>
            <span>{{ pageTitle }}</span>
          </div>
        }
        <div class="topbar-spacer"></div>
        <div class="topbar-actions">
          @if (username) {
            <div class="topbar-user">
              <div class="topbar-avatar">{{ username.charAt(0).toUpperCase() }}</div>
              <div class="topbar-user-info">
                <span class="topbar-username">{{ username }}</span>
                <button mat-button
                  (click)="logout()"
                  aria-label="topbar-deconnexion-bouton"
                  class="topbar-logout-btn">
                  <mat-icon>logout</mat-icon>
                  Déconnexion
                </button>
              </div>
            </div>
          }
        </div>
      </header>
      <!-- Contenu -->
      <main class="app-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
}

